<template>
  <div class="row">
    <div class="container container-folder-structure">
      <table class="table table-borderless">
        <tbody class="body">
          <!-- Contents-->
          <folder-tree></folder-tree>
        </tbody>
      </table>
    </div>
    <div class="container container-folder-details">
      <table class="table table-borderless">
        <tbody class="body">
          <tr>
            <td class="col-6 head">No. of Files</td>
            <td class="col-6 head">Folder Size</td>
          </tr>
          <tr>
            <td class="content">
              {{ transferStore.currentTransfer.fileCount }}
            </td>
            <td class="content">
              {{
                $filters.formatSizeUnits(
                  transferStore.currentTransfer.totalTransferSize
                )
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import FolderTree from "../FolderTree.vue";
import { useTransferStore } from "@/stores/content_review/transfer";

const transferStore: any = useTransferStore();
</script>

<style lang="scss" scoped>
.container-folder-structure {
  background: #ebebeb;
  display: flex;
  margin-top: 16px;
  padding: 16px;
  padding-bottom: 0;
  max-width: 96%;
  overflow: auto;
}
.container-folder-details {
  display: flex;
  padding: 16px;
  padding-bottom: 0;
  max-width: 96%;
  overflow: auto;
}
</style>
